import { render, staticRenderFns } from "./receiptTable.vue?vue&type=template&id=7493ff56"
import script from "./receiptTable.vue?vue&type=script&lang=js"
export * from "./receiptTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports